// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UAAsX","form":"styles_form__S+1H+","heading":"styles_heading__xUYa1","input":"styles_input__8UVoz","submit_btn":"styles_submit_btn__Dd5D8"};